'use strict';

var giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    util = require('../util'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    validator = require('../validator'),
    dynamicAddress = require('./dynamic-address'),
    progress = require('../progress'),
    b2borders = require('./b2borders'),
    bornModules = require('../helpers/born.modules').default,
    customTooltip = require('./product/tooltip'),
    barcode = require('../barcode');

/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder () {
    $('.order-items')
        .find('li.hidden:first')
        .prev('li')
        .append('<a class="toggle">View All</a>')
        .children('.toggle')
        .click(function () {
            $(this).parent().siblings('li.hidden').show();
            $(this).remove();
        });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
    var addresses = $('#addresses');
    if (addresses.length === 0) { return; }

    addresses.on('click', '.delete', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            $.ajax({
                url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax'),
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    page.redirect(Urls.addressesList);
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                } else {
                    page.refresh();
                }
            });
        }
    });
}

function selectAddressType() {
    $('.address-type-selector-profile').on('click','.address-type.selectable:not(.active)', function () {
        var $addressType = $('select[name$="_addressType"]');
        $('.address-type-selector-profile .address-type.active').removeClass('active');
        $addressType.val($(this).data('value'));
        $(this).addClass('active');
    });
}
/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
    $('.add-card').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                open: initializePaymentForm
            }
        });
    });

    var paymentList = $('.payment-list');
    if (paymentList.length === 0) { return; }

    util.setDeleteConfirmation(paymentList, String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD));

    $('form[name="payment-remove"]').on('submit', function (e) {
        e.preventDefault();
        // override form submission in order to prevent refresh issues
        var button = $(this).find('.delete');
        $('<input/>').attr({
            type: 'hidden',
            name: button.attr('name'),
            value: button.attr('value') || 'delete card'
        }).appendTo($(this));
        var data = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: data
        })
        .done(function () {
            page.redirect(Urls.paymentsList);
        });
    });
}

function scrollPage(offset) {
    $('html, body').animate({
        scrollTop: offset
    }, 'fast');
}

function initializePaymentForm() {
    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        dialog.close();
    });

}

function initHasReturnsBehaviour() {
    var $form = $('.js-order-return-form'),
        $submitButton = $form.find(".js-continue-button");
    if ($form.find('.js-returns-item').length) {
        $submitButton.removeAttr('disabled');
    } else {
        $submitButton.attr('disabled', 'disabled');
    }
}

function changeHistoryState(humanReadableURL) {
    history.pushState({}, "", humanReadableURL);
}

function initializeReturnForm() {
    var $form = $('.js-order-return-form'),
        formData;

    // Creating human readable url
    $('body').on('click', '.js-start-return-button, .js-continue-button', function() {
        var dataReturnUrlPart = $(this).data('return');
        changeHistoryState(dataReturnUrlPart);
    });
    $('body').on('click', '.js-start-return-button', function () {
        toggleReturnItem();
        qtyActions();
    });

    $('body').on('click', '#verify-email-link', function() {
    	document.getElementById('ResendVerifyMailForm').submit();
    });

    $form.on('click', ':submit', function(e){
        e.preventDefault();
        formData = $form.serializeArray();
        var shipmentNumber;
        var inputFieldPresent=$('#returnShipmentID').length>0
        if(inputFieldPresent){
            shipmentNumber = $('#returnShipmentID').val();
        }else{
            shipmentNumber = $(e.target).data('shipmentno')
        }
        formData.push({
            name: this.name,
            value: this.value
        });
        formData.push({
            name: 'shipmentNo',
            value: shipmentNumber
        });
        $form.submit();
    });

    $form.on('submit', function(e) {
        e.preventDefault();
        progress.show($form);
        $.ajax({
            type: 'post',
            url: $form.attr('action'),
            data: formData,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function(res) {
                var $jsOrderReturnContent = $('.js-order-return-content');

                $jsOrderReturnContent.html(res);
                var $errorMessages = $('.js-order-return-form .error-message');
                bornModules.toggle.init();

                // Disable "NEXT STEP" button in case if items  were returned or not eligible
                initHasReturnsBehaviour();

                // In order to hide Continue button if no returns selected or not applied terms
                $('.input-radio, .js-accept-terms').trigger('change');

                // Replace default select with selectic
                if ($jsOrderReturnContent.length) {
                    bornModules.selectTags.init('.js-return-reason-select');
                }
                
                if ($errorMessages.length) {
                    scrollPage($errorMessages.eq(0).closest('.line-item').prev().prevObject.offset().top);
                } else {
                    scrollPage(0);
                }
                progress.hide($form);
                barcode.initBarcodeByElements('.js-order-return-content .barcode-js');
            },
            error: function() {
                progress.hide($form);
            },
            complete: function(){
                orderProgressBarDisplay();
            }
        });
    });

    // Hide continue button if no returns selected
    $form.on('change', '.input-radio', function () {
        var $returnRadios = $('.js-return-radio:checked'),
            $submitButton = $form.find(".js-continue-button");
        if ($returnRadios.length) {
            $submitButton.removeAttr('disabled');
        } else {
            $submitButton.attr('disabled', 'disabled');
        }
    });
    
    // Accept terms
    $form
        .on('change', '.js-accept-terms', function () {
            var $termsCbox = $(this);
            var isCheckedTermsCbox = $termsCbox.is(':checked');
            var $submitButton = $form.find('.js-continue-button');
            
            if (sessionStorage.getItem('hasCheckedTerms')) {
                $termsCbox.prop('checked', true);
                isCheckedTermsCbox = true;
                sessionStorage.removeItem('hasCheckedTerms');
            }

            if (isCheckedTermsCbox) {
                $form.removeClass('has-not-checked-terms');
                $submitButton.removeAttr('disabled');
            } else {
                $submitButton.attr('disabled', 'disabled');
            }
        }).on('click', '.js-continue-button-area', function() {
            var isCheckedTermsCbox = $('.js-accept-terms').is(':checked');
            
            if (!isCheckedTermsCbox) {
                $form.addClass('has-not-checked-terms');
            }
        }).on('click', '.js-return-back', function() {
            var isCheckedTermsCbox = $('.js-accept-terms').is(':checked');

            if (isCheckedTermsCbox) {
                sessionStorage.setItem('hasCheckedTerms', 'true');
            }
        });
}

// Order progress expand Animation
function orderProgressExpand() {
    $(document).ready(function () {
       orderProgressBarDisplay();
    });
}

function orderProgressBarDisplay(){
    var valueElement = $('.progress-stage'), value = 1;
    if (valueElement.length > 0) {
        valueElement.each(function(){
            value = parseInt($(this).val());
            var parentEl=$(this).closest('.order--details__progress');
            parentEl.find('.progress-bar__expandable').addClass(`stage-${value}`);
            value > 0 && parentEl.find('.progress-bar__step').slice(0, value).addClass('active');
        })    
    }
}

/* Utility function used to check and uncheck interests 
 Scenarios : 
 1. Selected interest is ALL then we should uncheck individual interests.
 2. Selected interest in Individual interests then we should uncheck ALL interest checkbox. 
    As customer is selecting individual interests.
*/
function customerInterestsOnChangeEvent() {
	$("input[name=dwfrm_profile_customer_interests]").on('change', function (e) {
    let interests = $("input[name=dwfrm_profile_customer_interests]");
    /* Selected interest is ALL*/
	if ($(this).val().toUpperCase() == 'ALL') {
		$(interests).each(function() {
            if ($(this).val().toUpperCase() != 'ALL') {
                $(this).prop('checked', false)
            } 
          });
	}
	/* Selected interest is individual then uncheck ALL interest checkbox*/
	if ($(this).val().toUpperCase() != 'ALL') {
		$(interests).each(function() {
            if ($(this).val().toUpperCase() == 'ALL') {
                $(this).prop('checked', false)
            } 
          });
	}
    });
  }

//   To toggle item from returning list on clicking same checkbox
function toggleReturnItem() {
    $('body').off('click.toggleReturn').on('click.toggleReturn', '.select-item-for-return .control-label', function (e) {
        let $toggleOffRadio = $($(this).data('toggleoffid'));
        if ($toggleOffRadio.is(':checked')) {
            return;
        } 
        e.preventDefault();
        $toggleOffRadio.prop('checked', true);
        
        if($('input[type=radio]:checked.js-return-radio').length <=0) {
            $('.js-order-return-form')
                .find('.js-continue-button')
                .attr('disabled', 'disabled');
        }
    });
}

//  Quantity buttons +/- action
function qtyActions() {
    $('body').off('click.qtyActionMinus').off('click.qtyActionPlus');
    $('body').on('click.qtyActionMinus', '.line-item-quantity .qty-input .button.minus', function () {
        const $input = $(this).parent().find('input');
        let val = parseInt($input.val());
        if (val === 1) return;
        $input.val(--val);
    }).on('click.qtyActionPlus', '.line-item-quantity .qty-input .button.plus', function () {
        const $input = $(this).parent().find('input');
        const maxQty = parseInt($input.data('available'));
        let val = parseInt($input.val());
        if (val === maxQty) return;
        $input.val(++val);
    });
}

function toggleReturnTypeTabs() {
    $('.returns__type--tabs button').on('click', function() {
        $(this).addClass('active').siblings().removeClass('active');
        $('.returns__type--tabs-content, .returns__type--tabs-pagination').removeClass('active');
        $($(this).data('toggle')).addClass('active');
    });
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
    toggleFullOrder();
    initAddressEvents();
    dynamicAddress.init('.account__dynamic-address');
    initPaymentEvents();
    login.init();
    initializeReturnForm();
    tooltip.init();
    orderProgressExpand();
    toggleReturnTypeTabs();
    if (window.history.replaceState) {
		window.history.replaceState(null,null,window.location.href);
	}
    customerInterestsOnChangeEvent();
    
    $('.positivenumber').on('input',function(e) {
        this.value = this.value.replace(/\D/g,'');
    });
    selectAddressType();
    customTooltip.initShippingFeeCustomToolTipEvents();
    
    if(typeof initAccountPageEvents === 'function') {
		initAccountPageEvents();
	}
	barcode.init()
}
var account = {
    init: function () {
        initializeEvents();
        giftcert.init();
    },
    initCartLogin: function () {
        login.init();
    },
    customerInterestsOnChangeEvent : customerInterestsOnChangeEvent
};
 

module.exports = account;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/account.js